export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12028.742fcb78.jpg";